import {useTranslation} from "react-i18next";
import classnames from "classnames";

// interface Props {
//     status: string
// }

const OrderStatusBadge = (props) => {
    const { t } = useTranslation()
    const { status } = props

    let textColor = 'text-black';
    let bgColor = 'bg-indigo-600';

    switch (status) {
        case 'draft': bgColor = 'bg-gray-300'; break;
        case 'pending': bgColor = 'bg-gray-200'; break;
        case 'canceled': bgColor = 'bg-red-100'; break;
        case 'completed': bgColor = 'bg-[#ECFDF3]'; break;
        case 'ready': bgColor = 'bg-[#AFB5D9]'; break;
        case 'confirmed': bgColor = 'bg-indigo-50'; break;
    }

    return (
        <span
            className={classnames('inline-flex items-center justify-center px-3 py-2 mr-2 text-xs font-normal leading-none rounded-full capitalize', textColor, bgColor)}>
            {t(`status.${status}`)}
        </span>
    )
}

export default OrderStatusBadge;
